import React from 'react';
import cn from 'classnames';
import { Form, Checkbox as CheckboxAntd } from 'antd';
import { CheckboxProps } from './types';
import './style.scss';

export const Checkbox: React.FC<CheckboxProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  return (
    <div className={cn('form-item_checkbox', className)}>
      <Form.Item name={name} label={label} rules={rules} labelCol={{ span: 24 }} {...formItemProps}>
        <CheckboxAntd {...props} />
      </Form.Item>
    </div>
  );
};
